/**
 * Sources / Default / Components / Overwrites / Shared > Table
 *
 * @copyright 2024 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {extend} from '@ifabnpm/bootstrap/utils.js';
import {isElement} from '@ifabnpm/bootstrap/utils/is.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Data           from '@ifabnpm/bootstrap/dom/data.js';
import Manipulator    from '@ifabnpm/bootstrap/dom/manipulator.js';

// -------
// Private
// -------

const NAME     = 'table';
const DATA_KEY = `ifab.${NAME}`;
// const EVENT_KEY  = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const cleanUpEmptyParagraphs = (container) => {
	const siblingsPrev = SelectorEngine.prev(container, 'p:empty') ?? [];
	const siblingsNext = SelectorEngine.next(container, 'p:empty') ?? [];
	const childs       = SelectorEngine.find('p:empty', container) ?? [];
	const collection   = [...siblingsPrev, ...siblingsNext, ...childs];

	for (const element of collection) {
		element.remove();
	}
};

/**
 * ´Button´-Element initialisieren.
 *
 * @param {HTMLElement|String|null} [m='table']
 * @returns {HTMLElement}
 */
const tableScrollable = (m = 'table') => {
	const collection = (isElement(m)) ? [m] : SelectorEngine.find(m);

	for (const element of collection) {
		if (!Data.get(element, `${DATA_KEY}.initialized`)) {
			let figureWrap = SelectorEngine.parents(element, 'figure')[0];

			if (figureWrap) {
				if (!element.classList.contains('table')) {
					Manipulator.addClass(element, 'table');
				}
			} else {
				// `<figure/>` gernerieren und nach der Tabelle einfügen.
				figureWrap = Manipulator.elementAfter('<figure class="table-container"/>', element);

				// Tabelle in `<figure/>` verschieben.
				Manipulator.elementAppend(figureWrap, element);
			}

			cleanUpEmptyParagraphs(figureWrap);

			Manipulator.removeClass(figureWrap, 'table');
			Manipulator.addClass(figureWrap, 'table-container');

			figureWrap.style.overflowX = 'auto';

			// Initialisierungsstatus setzen.
			Data.set(element, `${DATA_KEY}.initialized`, true);
		}
	}
};

// ------
// Public
// ------

// Export
export default {
	makeScrollable: tableScrollable
};
